package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.User
import com.ijoin.data.model.UserFollowState
import com.ijoin.data.model.UserProfile
import io.ktor.client.call.*
import io.ktor.client.request.*

class UserApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/users"

    suspend fun getUserProfile(userId: String): Result<UserProfile> {
        return safeApiCall {
            client.get("$baseUrl/$userId/profile") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun followUser(userId: String): Result<UserFollowState> {
        return safeApiCall {
            client.post("$baseUrl/$userId/follow") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun unfollowUser(userId: String): Result<UserFollowState> {
        return safeApiCall {
            client.delete("$baseUrl/$userId/follow") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getFollowingUsers(userId: String): Result<List<User>> {
        return safeApiCall {
            client.get("$baseUrl/$userId/following") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }
}
